import React from "react";
import PageTitle from "../../../components/PageTitle";
import TableWithAddForm from "../../../../../components/TableWithAddForm";
import { Row, Col, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { region, isRegionLoading } from "../../../selectors/regions";
import {
  regionPageLoad,
  regionUpdateRequest,
  regionEmailAddRequest,
  regionEmailDeleteRequest,
} from "../../../actions/regions";
import { push } from "react-router-redux";
import RegionForm from "../../../components/forms/Region";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";

export default props =>
  isNaN(props.match.params.id) ? (
    <PageNotFound />
  ) : (
    <EditRegionPage regionId={parseInt(props.match.params.id, 10)} />
  );

const EditRegionPage = connect(
  (state, ownProps) => ({
    region: region(state),
    loading: isRegionLoading(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(regionPageLoad(ownProps.regionId)),
    onSave: formData =>
      dispatch(regionUpdateRequest(ownProps.regionId, formData)),
    onAddEmail: email =>
      dispatch(regionEmailAddRequest(ownProps.regionId, email)),
    onDeleteEmail: email =>
      dispatch(regionEmailDeleteRequest(ownProps.regionId, email)),
    onRegionList: () => dispatch(push("/regions")),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.loading) {
      return <PageTitle title="Loading..." />;
    }

    return (
      <div id="edit-region-page">
        <PageTitle title="Edit Region" />
        <div>
          <a
            id="back"
            style={{ cursor: "pointer" }}
            onClick={props.onRegionList}
          >
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to regions list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Region data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <RegionForm
                  region={props.region}
                  onSave={props.onSave}
                  disabled={props.region.generalDataSaveInProgress}
                  backendError={props.region.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>

        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              Region email addresses
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <TableWithAddForm
                  title="Email"
                  email
                  helpText="Enter the contact email addresses that are common to this Region. These will appear in the contact info for any Engineers associated with this Region."
                  disabled={props.region.emailAddInProgress}
                  backendError={props.region.emailAddError}
                  data={props.region.emails}
                  onAdd={props.onAddEmail}
                  onDelete={props.onDeleteEmail}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/regions/Edit.js